<template>
  <div style="display: none;">
    <!-- 此组件仅用于设置 CSS 变量，不渲染任何内容 -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ThemeStyles',
  computed: {
    ...mapGetters(['domainConfig'])
  },
  watch: {
    domainConfig: {
      handler (newConfig) {
        this.setCssVariables(newConfig);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    setCssVariables (config) {
      if (!config || typeof window === 'undefined') return;

      // 设置首页背景图变量
      if (config.homeBackground) {
        console.log(config.homeBackground.pc);
        document.documentElement.style.setProperty(
          '--home-bg-pc',
          `url('${config.homeBackground.pc}')`
        );
        document.documentElement.style.setProperty(
          '--home-bg-mobile',
          `url('${config.homeBackground.mobile}')`
        );
      }
    }
  }
}
</script> 